// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconCommonCloudUpload_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s16IconSvg = html `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M2.08129 6.01224C2.38814 3.71463 4.4375 2 6.83333 2C8.30811 2 9.63882 2.64317 10.5224 3.66805C10.5565 3.66713 10.5907 3.66667 10.625 3.66667C12.3972 3.66667 13.9346 4.91642 14.2071 6.62335C15.2784 7.3485 16 8.5544 16 9.94444C16 12.2297 14.0693 14 11.7917 14H10V12H11.7917C13.0578 12 14 11.0343 14 9.94444C14 9.1727 13.538 8.47447 12.8118 8.12113L12.235 7.84043L12.2496 7.19905C12.2499 7.1883 12.25 7.1775 12.25 7.16667C12.25 6.38366 11.569 5.66667 10.625 5.66667C10.502 5.66667 10.3828 5.67926 10.2687 5.70284L9.59744 5.84158L9.22591 5.2656C8.74366 4.51797 7.86219 4 6.83333 4C5.245 4 4.04167 5.21445 4.04167 6.61111L4.04173 6.62869L4.04636 7.28796L3.44227 7.55201C2.56814 7.93409 2 8.75373 2 9.66667C2 10.9099 3.07275 12 4.5 12H6V14H4.5C2.06126 14 0 12.1053 0 9.66667C0 8.11254 0.844377 6.77327 2.08129 6.01224Z" class="svg-bg"/>
  <path d="M8 7L11 11H9V16H7V11H5L8 7Z" class="svg-bg"/>
</svg>
`;
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M5.5 9.5C5.5 7.01472 7.51472 5 10 5C11.8482 5 13.4384 6.1144 14.1311 7.71199L14.5365 8.6471L15.4637 8.22397C15.7782 8.08046 16.1283 8 16.5 8C17.8807 8 19 9.11929 19 10.5C19 10.6801 18.9811 10.8548 18.9456 11.0224L18.7602 11.8962L19.6076 12.1786C20.999 12.6423 22 13.9556 22 15.5C22 17.433 20.433 19 18.5 19H15V21H18.5C21.5376 21 24 18.5376 24 15.5C24 13.3611 22.7795 11.5092 20.9989 10.5995C20.9996 10.5664 21 10.5332 21 10.5C21 8.01472 18.9853 6 16.5 6C16.1718 6 15.8513 6.03528 15.5421 6.10238C14.3995 4.24243 12.3457 3 10 3C6.41015 3 3.5 5.91015 3.5 9.5L3.50015 9.54429C1.43522 10.492 0 12.5773 0 15C0 18.3137 2.68629 21 6 21H9V19H6C3.79086 19 2 17.2091 2 15C2 13.1969 3.19378 11.6701 4.83639 11.1716L5.64666 10.9257L5.5377 10.086C5.51287 9.89464 5.5 9.69907 5.5 9.5Z" class="svg-bg"/>
  <path d="M11 24V17H8L12 12L16 17H13V24H11Z" class="svg-bg"/>
</svg>
`;
/**
 * IconCommonCloudUpload is a generated icon component.
 */
let IconCommonCloudUpload = IconCommonCloudUpload_1 = class IconCommonCloudUpload extends IconBaseElement {
    render() {
        return html `${IconCommonCloudUpload_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconCommonCloudUpload.icons = new Map([
    ['s8', _s16IconSvg],
    ['s12', _s16IconSvg],
    ['s16', _s16IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconCommonCloudUpload = IconCommonCloudUpload_1 = __decorate([
    customElement('zui-icon-common-cloud-upload')
], IconCommonCloudUpload);
export { IconCommonCloudUpload };
